export const pagination= {
    perPageLimit: 10,
    csmrtPerPageLimit: 15,
}